import { SortDropdownOption } from '@immosky/types';

export const availableSortOptions: SortDropdownOption[] = [
  {
    text: 'filters.sort.newest',
    value: 'newest',
  },
  {
    text: 'filters.sort.lowestPrice',
    value: 'lowest_price',
  },
  {
    text: 'filters.sort.highestPrice',
    value: 'highest_price',
  },
];
